import React, { useState } from "react";
import Spinner from "react-bootstrap/Spinner";
import { useSessionContext } from "components/Session";
import { newSession } from "api.mjs";
import log from "loglevel";
import "sass/awaiting-confirmation.scss";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { IconContext } from "react-icons";

const ReceivedConfirmationCode = ({
  email,
  confirmationId,
  confirmationCode,
  setLoginState,
  setShowModal,
  onLoginSuccess,
}) => {
  const { sessionContext, setSessionContext } = useSessionContext();
  const [loggingIn, setLoggingIn] = useState(false);
  log.debug("AwaitingConfirmation RENDER confirmation_id", confirmationId);

  const createNewSession = (sessionContext, setSessionContext) => {
    newSession({ context: { sessionContext } })
      .then((serverSessionContext) => {
        log.debug("Server Returned:", serverSessionContext);
        const newSessionContext = {
          ...sessionContext,
          ...serverSessionContext,
          isLoggedIn: true,
          userInfo: { email },
        };
        setSessionContext(newSessionContext);
        setLoggingIn(false);
        setShowModal(false);
        onLoginSuccess && onLoginSuccess(newSessionContext);
        // syncProfile({ context: { sessionContext: newSessionContext } });
      })
      .catch((error) => {
        log.error("Unexpected error while logging in:", error);
        log.error(typeof error);
        log.info(error);
        setLoggingIn(false);
        // setError(error);
      });
  };

  const doLogin = () => {
    log.debug("Logging in..");
    setLoggingIn(true);
    const newSessionContext = {
      isAdminUser: false,
      loginWithEmail: {
        email,
        confirmation_id: confirmationId,
        confirmation_code: confirmationCode,
      },
    };
    createNewSession(newSessionContext, setSessionContext);
  };

  return (
    <>
      <div className="received-content">
        <p className="text-rcv">
          Your email has been confirmed!
          <IconContext.Provider
            value={{ color: "green", className: "global-class-name" }}
          >
            <AiOutlineCheckCircle className="ms-1" />
          </IconContext.Provider>
        </p>
        <p className="text-rcv">Click the button below to continue.</p>
        <div className="btn-container">
          <button
            disabled={!!loggingIn}
            onClick={doLogin}
            type="submit"
            className="btn btn-primary"
          >
            {loggingIn ? (
              <>
                <Spinner
                  as="span"
                  animation="grow"
                  role="status"
                  aria-hidden="true"
                  size="sm"
                />
                Working...
              </>
            ) : (
              <>Continue</>
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default ReceivedConfirmationCode;
